import React from 'react';

import { Icon28SearchStarsOutline } from '@vkontakte/icons';
import {
  Button,
  FormItem,
  FormLayout,
  Input,
  Spacing,
  Text,
  Title,
} from '@vkontakte/vkui';

import styles from './MobileUserEnteringPage.module.css';
import { MobileUserEnteringPageProps } from './types';
import { PaymentLayout } from '../../../panels/PredictionPanel/MobilePredictionPanel/components/PaymentLayout';

export const MobileUserEnteringPage: React.FC<MobileUserEnteringPageProps> = ({
  error,
  textInput,
  onTextInputChange,
  handleUserSearchButton,
  delayAnimation,
  ref,
  handlePayButtonClick
}) => {
  return (
    <PaymentLayout delayAnimation={delayAnimation} ref={ref}>
      <Title 
        level="2" 
        weight="2" 
        className={styles.title}
      >
        Узнать профессиональный тип друга
      </Title>

      <Spacing size={16} />

      <FormLayout>
        <FormItem
          top="Ссылка на страницу пользователя"
          status={error ? 'error' : 'default'}
          bottom={ error }
        >
          <Input
            value={textInput}
            type="text"
            placeholder="Введите ссылку"
            onChange={onTextInputChange}
          />
        </FormItem>
      </FormLayout>

      <Spacing size={8} />

      <div style={{ margin: '0 16px' }}>
        <Button 
          mode="tertiary"
          size="m"
          before={<Icon28SearchStarsOutline />}
          stretched
          onClick={handleUserSearchButton}
        >
          Воспользоваться поиском
        </Button>

        <Spacing size={12} />

        <Text className={styles.text}>
          Оплатите голосами и узнайте, что страницы ваших друзей говорят об их профессиональном типе      
        </Text>

        <Spacing size={12} />

        <Button 
          size="l" 
          mode="primary"
          stretched
          onClick={handlePayButtonClick}
        >
          Оплатить и узнать результаты
        </Button>

        <Spacing size={24} />
      </div>
    </PaymentLayout>
  );
};


